import clsx from 'clsx';

import type { IconProps } from 'components/Icon';

import styles from './VarIndicator.module.css';

import { Icon } from 'components/Icon';

export type StatusType = 'DRAFT' | 'REJECTED' | 'SUBMITTED' | 'ACTIVE';

export interface VarIndicatorProps {
  label: Record<StatusType, string>;
  variant?: StatusType;
  maxSteps?: number;
  currentStep?: number;
  onClick?: () => void;
}

const ICON_NAMES = {
  DRAFT: 'CircleLarge',
  REJECTED: 'CircleLarge',
  SUBMITTED: 'CircleLargeDotted',
  ACTIVE: 'SignalActive',
};

export const VarIndicator = ({ label, variant = 'DRAFT', maxSteps, currentStep = 1, onClick }: VarIndicatorProps) => (
  <button
    className={clsx(styles['var-indicator__container'], styles[`var-indicator__container--${variant.toLowerCase()}`])}
    onClick={onClick}
  >
    <Icon name={ICON_NAMES[variant] as IconProps['name']} size={16} />
    <span className={styles['var-indicator__label']}>{label[`${variant}`]}</span>
    {maxSteps && maxSteps > 0 && variant === 'SUBMITTED'
      ? Array.from({ length: maxSteps }, (_, idx) => idx + 1).map((step) => (
          <div key={step} className={styles['var-indicator__step-container']}>
            <Icon name={step <= currentStep ? 'CircleSmallFilled' : 'CircleSmall'} />
          </div>
        ))
      : null}
  </button>
);
